var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 26 26",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.643,21c0,0.275-0.225,0.5-0.5,0.5h-13c-0.275,0-0.5-0.225-0.5-0.5V3c0-0.275,0.225-0.5,0.5-0.5h13 c0.275,0,0.5,0.225,0.5,0.5v3.454h1V2c0-1.1-0.9-2-2-2h-12c-1.1,0-2,0.9-2,2v22c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-4.454h-1V21z  M8.643,0.923h2c0.275,0,0.5,0.159,0.5,0.354c0,0.195-0.225,0.354-0.5,0.354h-2c-0.275,0-0.5-0.159-0.5-0.354 C8.143,1.083,8.367,0.923,8.643,0.923z M4.143,0.778c0.275,0,0.5,0.224,0.5,0.5c0,0.276-0.225,0.5-0.5,0.5s-0.5-0.224-0.5-0.5 C3.643,1.002,3.867,0.778,4.143,0.778z M9.643,24.936c-0.659,0-1.193-0.533-1.193-1.192c0-0.66,0.534-1.194,1.193-1.194 c0.659,0,1.194,0.534,1.194,1.194C10.837,24.4,10.302,24.936,9.643,24.936z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.996,9.287l6.697,3.348c1.009,0.504,2.89,0.504,3.897,0l6.697-3.348c-0.25-1.046-1.189-1.833-2.309-1.833H9.304 C8.186,7.454,7.245,8.241,6.996,9.287z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.945,13.343c-0.62,0.31-1.438,0.48-2.303,0.48c-0.866,0-1.685-0.171-2.304-0.48l-1.852-0.926l-4.561,2.28v1.472 c0,1.308,1.07,2.377,2.377,2.377H21.98c1.308,0,2.377-1.069,2.377-2.377v-1.472l-4.562-2.279L17.945,13.343z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.683,11.975 24.357,13.812 24.357,10.138  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.927,13.812 10.602,11.975 6.927,10.138  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.b948b0231fcb6efd6b25e21d26ce00c5.svg";
export { ForwardRef as ReactComponent };